import produce from 'immer'
import { ToppagesaboutusAction, ToppagesaboutusActionTypes } from '../actions/toppagesaboutusActions'
import { ApiStatus, IToppagesaboutusItem } from '../models'

export const initialToppagesaboutusState: IToppagesaboutusState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  toppagesaboutus: [],
  foundtoppagesaboutus: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function toppagesaboutusReducer(state: IToppagesaboutusState = initialToppagesaboutusState, action: ToppagesaboutusAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case ToppagesaboutusActionTypes.SEARCH_TOPPAGESABOUTUS:
        draft.searchString = action.searchOptions.searchString
        break
      case ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case ToppagesaboutusActionTypes.FOUND_TOPPAGESABOUTUS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundtoppagesaboutus.push(...action.payload.toppagesaboutus.docs)
          : (draft.foundtoppagesaboutus = action.payload.toppagesaboutus.docs)
        draft.totalDocs = action.payload.toppagesaboutus.totalDocs
        break

      case ToppagesaboutusActionTypes.LOAD_TOPPAGESABOUTUS:
      case ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundtoppagesaboutus = []
        break

      case ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case ToppagesaboutusActionTypes.LOADED_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.toppagesaboutus = action.payload.toppagesaboutus.docs
        draft.totalDocs = action.payload.toppagesaboutus.totalDocs
        break

      case ToppagesaboutusActionTypes.ADD_TOPPAGESABOUTUS:
      case ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagesaboutusActionTypes.ADDED_TOPPAGESABOUTUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.toppagesaboutus.push(action.payload.toppagesaboutus.docs[0])
        if (draft.searchString) draft.foundtoppagesaboutus.push(action.payload.toppagesaboutus.docs[0])
        break

      case ToppagesaboutusActionTypes.REMOVE_TOPPAGEABOUTUS:
        draft.toppagesaboutus.splice(
          draft.toppagesaboutus.findIndex((toppageaboutus) => toppageaboutus._id === action.payload._id),
          1
        )
        break

      case ToppagesaboutusActionTypes.SOFT_REMOVE_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesaboutusActionTypes.SOFT_REMOVED_TOPPAGESABOUTUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagesaboutus.splice(
          draft.toppagesaboutus.findIndex((toppageaboutus) => toppageaboutus._id === action.payload._id),
          1
        )
        break

      case ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagesaboutusActionTypes.EDIT_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesaboutusActionTypes.EDITED_TOPPAGESABOUTUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagesaboutus[draft.toppagesaboutus.findIndex((toppageaboutus) => toppageaboutus._id === action.payload._id)] = action.payload
        draft.foundtoppagesaboutus[draft.foundtoppagesaboutus.findIndex((toppageaboutus) => toppageaboutus._id === action.payload._id)] =
          action.payload
        break

      case ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface IToppagesaboutusState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  toppagesaboutus: IToppagesaboutusItem[]
  foundtoppagesaboutus: IToppagesaboutusItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
